<slick-dialog #dialogRef header="Business Development Contact" [width]='800'>
	<div *ngIf="businessDevelopmentContact" class="mx-3 pt-3">
		<div class="d-flex mb-3">
			<div class="d-flex flex-fill flex-column me-3">
				<label for="bdContactFirstName">First Name</label>
				<input id="bdContactFirstName" type="text" class="form-control flex-fill" [(ngModel)]="businessDevelopmentContact.contact.firstName" [slick-validation-indicator]="businessDevelopmentContact.contact.firstName" />
			</div>
			<div class="d-flex flex-fill flex-column">
				<label for="bdContactLastName">Last Name</label>
				<input id="bdContactLastName" type="text" class="form-control flex-fill" [(ngModel)]="businessDevelopmentContact.contact.lastName" [slick-validation-indicator]="businessDevelopmentContact.contact.lastName" />
			</div>
		</div>

		<div class="d-flex flex-fill mb-1">
			<div class="d-flex flex-fill flex-column me-1">
				<label>Position</label>
				<slick-drop-down [items]="rolesDropDown"
								 [(ngModel)]="businessDevelopmentContact.businessDevelopmentContactRoleId"></slick-drop-down>
			</div>

			<div class="d-flex align-items-end">
				<button class="btn btn-outline-primary" (click)="editRoles()"><i class="far fa-pencil text-primary"></i></button>
			</div>
		</div>
		<div class="d-flex mb-2">
			<div class="me-2">
				<input type="checkbox" [(ngModel)]="businessDevelopmentContact.isAgent" />Agent
			</div>
			<div>
				<input type="checkbox" [(ngModel)]="businessDevelopmentContact.isAdjuster" />Adjuster
			</div>
		</div>

		<contact-edit #contactEditRef
					  [contactModel]="businessDevelopmentContact.contact"
					  hideFirstAndLastName="true"
					  hideCompanyName="true"
					  showQuickbooksName="false"
					  showButtons="false"></contact-edit>

		<div class="d-flex mt-2">
			<div class="flex-fill">
				<label>Note</label>
				<input type="text" class="form-control w-100" [(ngModel)]="businessDevelopmentContact.note" />
			</div>
		</div>

		<div class="d-flex mt-2">
			<div class="flex-fill">
				<input type="checkbox" [(ngModel)]="businessDevelopmentContact.isActive" />Active
			</div>
		</div>
	</div>

		<slick-dialog-footer>
			<button type="button" [slick-button-spinner]="spinnerStatus" class="btn btn-outline-primary save-button" (click)="onSave()"><i class="far fa-save"></i>&nbsp;Save</button>
			<button type="button" class="btn btn-outline-danger cancel-button" (click)="onCancel()"><i class="far fa-ban"></i>&nbsp;Cancel</button>
		</slick-dialog-footer>
</slick-dialog>


<business-development-contact-roles-dialog #businessDevelopmentContactRolesDialogRef></business-development-contact-roles-dialog>